export function getCampaignStatusDetails(status: string | undefined): {
  isCampaignActive: boolean;
  isResultActive: boolean | undefined;
  isOptinClosed: boolean;
} {
  if (!status) {
    return {
      isCampaignActive: false,
      isResultActive: undefined,
      isOptinClosed: false,
    };
  }
  const upperStatus = status.toUpperCase();

  return {
    isCampaignActive: upperStatus !== 'DISABLED',
    isResultActive: upperStatus === 'REDEEM_ENABLED',
    isOptinClosed: upperStatus === 'OPTIN_DISABLED' || upperStatus === 'REDEEM_ENABLED',
  };
}
